/**
 * @generated SignedSource<<2616eb4af55decaf8b6552376ae9f497>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarketingEmailUnsubscribesViewQuery$variables = {
  marketingEmailId: string;
};
export type MarketingEmailUnsubscribesViewQuery$data = {
  readonly marketingEmailUnsubscribes: ReadonlyArray<{
    readonly contact: {
      readonly emailAddress?: string | null | undefined;
      readonly familyName?: string;
      readonly givenName?: string;
      readonly id: string;
      readonly teamName?: string;
    } | null | undefined;
    readonly contactIdentifier: string;
    readonly unsubscribeReason: string | null | undefined;
    readonly unsubscribedAt: any | null | undefined;
  }>;
};
export type MarketingEmailUnsubscribesViewQuery = {
  response: MarketingEmailUnsubscribesViewQuery$data;
  variables: MarketingEmailUnsubscribesViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "marketingEmailId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "marketingEmailId",
    "variableName": "marketingEmailId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactIdentifier",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unsubscribedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unsubscribeReason",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailAddress",
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "givenName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "familyName",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "type": "PersonContact",
  "abstractKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "type": "TeamContact",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingEmailUnsubscribesViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ListMembership",
        "kind": "LinkedField",
        "name": "marketingEmailUnsubscribes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarketingEmailUnsubscribesViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ListMembership",
        "kind": "LinkedField",
        "name": "marketingEmailUnsubscribes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f2168f0205e4ade68b8bc1c4f74c046d",
    "id": null,
    "metadata": {},
    "name": "MarketingEmailUnsubscribesViewQuery",
    "operationKind": "query",
    "text": "query MarketingEmailUnsubscribesViewQuery(\n  $marketingEmailId: ID!\n) {\n  marketingEmailUnsubscribes(marketingEmailId: $marketingEmailId) {\n    contactIdentifier\n    unsubscribedAt\n    unsubscribeReason\n    contact {\n      __typename\n      id\n      ... on PersonContact {\n        givenName\n        familyName\n        emailAddress\n      }\n      ... on TeamContact {\n        teamName\n        emailAddress\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "74520b96f41ca915de56643ec171018a";

export default node;
